var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c("el-card", { staticClass: "box-card" }, [
        _c(
          "div",
          { staticClass: "clearfix" },
          [
            _c(
              "el-form",
              { attrs: { inline: "", size: "small", "label-width": "80px" } },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "用户UID：" } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "150px" },
                      attrs: { placeholder: "用户UID", clearable: "" },
                      model: {
                        value: _vm.tableFrom.uid,
                        callback: function ($$v) {
                          _vm.$set(_vm.tableFrom, "uid", $$v)
                        },
                        expression: "tableFrom.uid",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "手机号：" } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "150px" },
                      attrs: { placeholder: "手机号", clearable: "" },
                      model: {
                        value: _vm.tableFrom.uidPhone,
                        callback: function ($$v) {
                          _vm.$set(_vm.tableFrom, "uidPhone", $$v)
                        },
                        expression: "tableFrom.uidPhone",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "审批状态：" } },
                  [
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "130px" },
                        attrs: { placeholder: "全部", clearable: "" },
                        model: {
                          value: _vm.tableFrom.status,
                          callback: function ($$v) {
                            _vm.$set(_vm.tableFrom, "status", $$v)
                          },
                          expression: "tableFrom.status",
                        },
                      },
                      [
                        _c("el-option", {
                          attrs: { label: "待审批", value: 0 },
                        }),
                        _c("el-option", {
                          attrs: { label: "已确认", value: 1 },
                        }),
                        _c("el-option", {
                          attrs: { label: "已拒绝", value: 2 },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "支付方式：" } },
                  [
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "130px" },
                        attrs: { placeholder: "全部", clearable: "" },
                        model: {
                          value: _vm.tableFrom.payType,
                          callback: function ($$v) {
                            _vm.$set(_vm.tableFrom, "payType", $$v)
                          },
                          expression: "tableFrom.payType",
                        },
                      },
                      [
                        _c("el-option", {
                          attrs: { label: "现金", value: "cash" },
                        }),
                        _c("el-option", {
                          attrs: { label: "企业资源", value: "resource" },
                        }),
                        _c("el-option", {
                          attrs: { label: "其他", value: "other" },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "时间选择：" } },
                  [
                    _c("el-date-picker", {
                      staticStyle: { width: "260px" },
                      attrs: {
                        "value-format": "yyyy-MM-dd",
                        format: "yyyy-MM-dd",
                        size: "small",
                        type: "daterange",
                        "start-placeholder": "开始时间",
                        "end-placeholder": "结束时间",
                      },
                      on: { change: _vm.onchangeTime },
                      model: {
                        value: _vm.timeVal,
                        callback: function ($$v) {
                          _vm.timeVal = $$v
                        },
                        expression: "timeVal",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.getList(1)
                          },
                        },
                      },
                      [_vm._v("搜索")]
                    ),
                    _c("el-button", { on: { click: _vm.handleReset } }, [
                      _vm._v("重置"),
                    ]),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "hasPermi",
                            rawName: "v-hasPermi",
                            value: ["admin:kx:manual:create"],
                            expression: "['admin:kx:manual:create']",
                          },
                        ],
                        attrs: { type: "success" },
                        on: {
                          click: function ($event) {
                            _vm.createDialogVisible = true
                          },
                        },
                      },
                      [_vm._v("新增入账")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "el-card",
        { staticClass: "box-card mt14" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData.data,
                size: "mini",
                "highlight-current-row": "",
              },
            },
            [
              _c("el-table-column", {
                attrs: { type: "index", label: "序号", width: "60" },
              }),
              _c("el-table-column", {
                attrs: { prop: "uid", label: "用户UID", width: "100" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "nickname",
                  label: "用户昵称",
                  "min-width": "120",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "phone", label: "手机号", width: "120" },
              }),
              _c("el-table-column", {
                attrs: { prop: "amount", label: "金额(元)", width: "100" },
              }),
              _c("el-table-column", {
                attrs: { label: "专区类型", width: "110" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: scope.row.zoneType === 1 ? "" : "success",
                              size: "small",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  scope.row.zoneType === 1
                                    ? "企业活动"
                                    : "商家赋能"
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "支付方式", width: "90" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.payType === "cash"
                          ? _c("span", [_vm._v("现金")])
                          : scope.row.payType === "resource"
                          ? _c("span", [_vm._v("企业资源")])
                          : _c("span", [_vm._v("其他")]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "payDesc",
                  label: "支付描述",
                  "min-width": "120",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "凭证图片", width: "80" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.voucherImage
                          ? _c("el-image", {
                              staticStyle: { width: "40px", height: "40px" },
                              attrs: {
                                src: scope.row.voucherImage,
                                "preview-src-list": [scope.row.voucherImage],
                                fit: "cover",
                              },
                            })
                          : _c("span", [_vm._v("-")]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "状态", width: "90" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type:
                                scope.row.status === 0
                                  ? "warning"
                                  : scope.row.status === 1
                                  ? "success"
                                  : "danger",
                              size: "small",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  scope.row.status === 0
                                    ? "待审批"
                                    : scope.row.status === 1
                                    ? "已确认"
                                    : "已拒绝"
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "createTime",
                  label: "创建时间",
                  "min-width": "150",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "操作", width: "160", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.status === 0
                          ? [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "text", size: "mini" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleApprove(
                                        scope.row.id,
                                        true
                                      )
                                    },
                                  },
                                },
                                [_vm._v("通过")]
                              ),
                              _c(
                                "el-button",
                                {
                                  staticStyle: { color: "#f56c6c" },
                                  attrs: { type: "text", size: "mini" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleApprove(
                                        scope.row.id,
                                        false
                                      )
                                    },
                                  },
                                },
                                [_vm._v("拒绝")]
                              ),
                            ]
                          : _vm._e(),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.handleDetail(scope.row.id)
                              },
                            },
                          },
                          [_vm._v("详情")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "block" },
            [
              _c("el-pagination", {
                attrs: {
                  "page-sizes": [20, 40, 60],
                  "page-size": _vm.tableFrom.limit,
                  "current-page": _vm.tableFrom.page,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.tableData.total,
                  background: "",
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.pageChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "新增手动入账",
            visible: _vm.createDialogVisible,
            width: "550px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.createDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "createForm",
              attrs: {
                model: _vm.createForm,
                "label-width": "100px",
                size: "small",
                rules: _vm.createRules,
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "用户UID", prop: "uid" } },
                [
                  _c("el-input-number", {
                    attrs: { min: 1 },
                    model: {
                      value: _vm.createForm.uid,
                      callback: function ($$v) {
                        _vm.$set(_vm.createForm, "uid", $$v)
                      },
                      expression: "createForm.uid",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "消费金额", prop: "amount" } },
                [
                  _c("el-input-number", {
                    attrs: { min: 0.01, precision: 2 },
                    model: {
                      value: _vm.createForm.amount,
                      callback: function ($$v) {
                        _vm.$set(_vm.createForm, "amount", $$v)
                      },
                      expression: "createForm.amount",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "专区类型", prop: "zoneType" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.createForm.zoneType,
                        callback: function ($$v) {
                          _vm.$set(_vm.createForm, "zoneType", $$v)
                        },
                        expression: "createForm.zoneType",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _vm._v("企业活动专区"),
                      ]),
                      _c("el-radio", { attrs: { label: 2 } }, [
                        _vm._v("商家赋能专区"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "支付方式", prop: "payType" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.createForm.payType,
                        callback: function ($$v) {
                          _vm.$set(_vm.createForm, "payType", $$v)
                        },
                        expression: "createForm.payType",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: "cash" } }, [
                        _vm._v("现金"),
                      ]),
                      _c("el-radio", { attrs: { label: "resource" } }, [
                        _vm._v("企业资源"),
                      ]),
                      _c("el-radio", { attrs: { label: "other" } }, [
                        _vm._v("其他"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "支付描述" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 2,
                      placeholder: "请输入支付说明",
                    },
                    model: {
                      value: _vm.createForm.payDesc,
                      callback: function ($$v) {
                        _vm.$set(_vm.createForm, "payDesc", $$v)
                      },
                      expression: "createForm.payDesc",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "凭证图片" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "凭证图片URL" },
                    model: {
                      value: _vm.createForm.voucherImage,
                      callback: function ($$v) {
                        _vm.$set(_vm.createForm, "voucherImage", $$v)
                      },
                      expression: "createForm.voucherImage",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.createDialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.handleCreate },
                },
                [_vm._v("提交")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "手动入账详情",
            visible: _vm.detailDialogVisible,
            width: "500px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.detailDialogVisible = $event
            },
          },
        },
        [
          _vm.detailData
            ? _c(
                "el-descriptions",
                { attrs: { column: 1, border: "", size: "small" } },
                [
                  _c("el-descriptions-item", { attrs: { label: "ID" } }, [
                    _vm._v(_vm._s(_vm.detailData.id)),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "用户UID" } }, [
                    _vm._v(_vm._s(_vm.detailData.uid)),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "金额" } }, [
                    _vm._v(_vm._s(_vm.detailData.amount) + " 元"),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "专区类型" } }, [
                    _vm._v(
                      _vm._s(
                        _vm.detailData.zoneType === 1
                          ? "企业活动专区"
                          : "商家赋能专区"
                      )
                    ),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "支付方式" } }, [
                    _vm.detailData.payType === "cash"
                      ? _c("span", [_vm._v("现金")])
                      : _vm.detailData.payType === "resource"
                      ? _c("span", [_vm._v("企业资源")])
                      : _c("span", [_vm._v("其他")]),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "支付描述" } }, [
                    _vm._v(_vm._s(_vm.detailData.payDesc || "-")),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "状态" } }, [
                    _vm._v(
                      _vm._s(
                        _vm.detailData.status === 0
                          ? "待审批"
                          : _vm.detailData.status === 1
                          ? "已确认"
                          : "已拒绝"
                      )
                    ),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "创建时间" } }, [
                    _vm._v(_vm._s(_vm.detailData.createTime)),
                  ]),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }